<nb-card class="bg-transparent">
  <nb-card-header class="pb-0">
    <div class="row mb-3">
      <div class="col-lg-4 col-12 text-lg-left">
        <h4 class="fw-semibold ls-1">Carrier List</h4>
      </div>
      <div class="col-lg-8 d-flex justify-content-end">
        <div class="d-flex justify-content-center gap-2">
          <!-- 1. Telephone Button -->
          <button (click)="telephone_click()" mat-raised-button class="new-compact-btn">
            <span class="fa-icon-wrapper"><i class="fas fa-phone-alt me-2"></i></span>
            {{ this.dispatchPhone }}
          </button>

          <!-- 2. Edit Dispatch Button -->
          <button (click)="editDispatch()" mat-raised-button color="primary" class="new-compact-btn">
            <span class="fa-icon-wrapper"><i class="fas fa-pen me-2"></i></span>
            Edit Dispatch
          </button>

          <div class="me-3 filter-badge-wrapper">
            <button
              mat-stroked-button
              class="btn text-dark btn-sm"
              (click)="clearFilters()"
            >
              <fa-icon [icon]="faBan" class="me-2"></fa-icon>Clear Filters
            </button>
            <span *ngIf="filterCount > 0" class="filter-badge">{{filterCount}}</span>
          </div>

          <!-- 4. New Carrier Button -->
          <button (click)="addCarrierClicked(false, null)" mat-raised-button color="primary" class="new-compact-btn">
            <span class="fa-icon-wrapper"><i class="fas fa-plus me-2"></i></span>
            New Carrier
          </button>
        </div>
      </div>

    </div>
    <div class="row mt-3">
      <div>
        <div class="d-flex justify-content-end gap-2">
          <div class="d-flex justify-content-between">
            <button mat-raised-button class="new-compact-btn" (click)="downloadFiles('Excel');">
              <span class="ls-1">
                <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                Excel
              </span>
            </button>
          </div>
        </div>
      </div>
        
    </div>
  </nb-card-header>
  <nb-card-body [nbSpinner]="carrierLoading">
    <div class="row">
      <div class="col-12">
        <ejs-grid
          #grid
          [id]="gridName"
          [dataSource]="allCarriers"
          [allowPaging]="true"
          [enableHover]="false"
          [allowSelection]="true"
          [allowSorting]="true"
          [allowFiltering]="true"
          [pageSettings]="pageSettings"
          [filterSettings]="filterSettings"
          [allowTextWrap]="true"
          [toolbar]="toolbarOptions"
          [columns]="allColumns"
          [enableStickyHeader]="true"
          [allowExcelExport]="true"
          [enablePersistence]="enablePersistence"
          height="600"
          (toolbarClick)="toolbarClick($event)"
          (actionComplete)="onActionComplete($event)"
          (dataBound)="onGridDataBound()"
          (rowDataBound)="onRowDataBound($event)"
          rowHeight="38"
        >
        </ejs-grid>
      </div>
    </div>
  </nb-card-body>
</nb-card>
<ng-template #carrierEditTemplate let-row>
  <ng-container *ngIf="!savingCarrierIds.has(row.id); else carrierSavingSpinner">
    <div class="d-flex">
      <button class="btn btn-sm btn-active-primary btn-icon-hover" (click)="addCarrierClicked(true, row.id)">
        <fa-icon style="cursor: pointer" [icon]="faPen"></fa-icon>
      </button>
      <button class="btn btn-sm btn-active-primary btn-icon-hover ms-1" (click)="confirmDelete(row.id)">
        <fa-icon style="cursor: pointer" [icon]="faTrash"></fa-icon>
      </button>
    </div>
  </ng-container>
  <ng-template #carrierSavingSpinner>
    <mat-spinner class="row-saving-spinner" [diameter]="20"></mat-spinner>
  </ng-template>
</ng-template>